import { CART_PAGINATION_WEB_240627 } from "@faire/web-api/indigofair/settings/CART_PAGINATION_WEB_240627";

import {
  getSettingValueWithoutAssignment,
  assignSetting,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingCartPaginationWeb = () =>
  getSettingValueWithoutAssignment(CART_PAGINATION_WEB_240627, false);

export const assignSettingCartPaginationWeb = () =>
  assignSetting(CART_PAGINATION_WEB_240627);
